export const FirebaseEvents = {
  PAGE_VIEW: 'page_view',
};

export enum ImageAspectRatio {
  LANDSCAPE = '16:9',
  SQUARE = '4:4',
  TILE = '4:3',
}

export const CREDIT_SCORES = ['740+', '670-739', '600-669', '560-599', 'Less than 560', 'Not Reported'] as const;

export const ELIGIBLE_CREDIT_SCORES = ['740+', '670-739', '600-669', '560-599', 'Not Reported'] as const;
